<div class="MD-head">
    <h2>{{'Maximum_sessions_exceeded'|translate}}</h2>
  </div>
  <div class="info">
    <label class="label-text">{{'Your_account_is_currently_in_use_on_multiple_devices'|translate}}</label>
  </div>
  <mat-dialog-content>
    <div >
      <div class="device_info" >
        <span class="devide-details" *ngFor="let device of devices?.deviceDetails?.deviceList">
            <div class="device-data name_bold">{{device?.device_model}}</div>
            <div class="device-data">{{'Last_session'|translate}}: {{getDate(device?.date)}}</div>
            <div class="device_signout"> 
                <button mat-flat-button color="accent" (click)="onSignOutDevice(device)">{{'Sign_out'|translate}}</button>
            </div>
        </span>
        <!-- <span class="devide-details">
            <div class="device-data name_bold">Macbook pro</div>
            <div class="device-data">Last Session: 17/04/24 3:00PM</div>
            <div class="device_signout"> 
                <button mat-flat-button color="accent" >Sign out</button>
            </div>
        </span> -->
      </div>
    </div> 
  </mat-dialog-content>
  <div style="padding: 20px 15px;">
    <div class="row">
      <div class="col btn-size"> <button mat-flat-button color="accent" (click)="onSignOutAllDevices()" class="btn-inc">{{'Sign_out_all_devices'|translate}}</button>
      </div>
      <div class="col btn-size"><button mat-flat-button color="primary" style="float: inline-end;" (click)="onBackToLogin()" class="btn-inc">{{'Back_to_Login'|translate}}</button></div>
    </div>
  </div>


